import * as HotelPriceLoadingStates from "./HotelPriceLoadingStates";

export function hasDirectLink(hotel) {
	return !!hotel.direct_link;
}

export function getUnavailableState(hotel) {
	return hasDirectLink(hotel)
		? HotelPriceLoadingStates.STATE_DIRECT_LINK_ONLY
		: HotelPriceLoadingStates.STATE_UNAVAILABLE;
}
